/**
 * POST /api/customer_users (type list / show-style envelopes) → UI rows.
 */

import { isErpApiSuccess } from "../erpClient";

/** Raw customer rows from ERP list/show response (minimal shape: id, name, mobile, …). */
export function extractCustomerUsersArray(res) {
  if (!res) return null;
  const d = res.data;
  if (Array.isArray(d)) return d;
  if (Array.isArray(d?.customers)) return d.customers;
  if (Array.isArray(d?.items)) return d.items;
  if (Array.isArray(d?.records)) return d.records;
  if (Array.isArray(d?.users)) return d.users;
  if (Array.isArray(d?.data)) return d.data;
  if (Array.isArray(d?.userss)) return d.userss;
  if (!isErpApiSuccess(res)) return null;
  return null;
}

/** Party / dropdown shape used by Purchase, Jangad, etc. */
export function mapCustomerUsersToPartyList(res) {
  const raw = extractCustomerUsersArray(res);
  if (!raw) return null;
  return raw.map((user) => ({
    id: user.id,
    fullName: user.name || "",
    name: user.name || "",
    mobile: user.mobile || "",
    email: user.email || "",
    city: user.city || "",
    address: user.address || "",
    state: user.state || "",
    area: user.area || user.Area || user.area_name || user.areaName || "",
    aadharNo: user.aadhar_no || "",
    panNo: user.pan_no || "",
    birthDate: user.birth_date || "",
    maritalStatus: user.marital_status || "",
    anniversaryDate: user.anniversary_date || "",
    saleBalance: user.sale_balance || "",
    balance: user.users_balance ?? user.balance ?? "",
    companyName: user.company_name || "",
    companyAddress: user.company_address || "",
    gstNumber: user.GST_number || user.gst_number || "",
    reference: user.reference || "",
    status: user.status || "",
  }));
}
